import { render } from "./DrawingTable.vue?vue&type=template&id=623051c8"
import script from "./DrawingTable.vue?vue&type=script&lang=js"
export * from "./DrawingTable.vue?vue&type=script&lang=js"

import "./DrawingTable.vue?vue&type=style&index=0&id=623051c8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__